import { autoUpdate, offset, shift, useFloating } from '@floating-ui/react-dom';

export const useSetupMenuFloating = ({ popperElement, referenceElement, isInfinityMode }) => {
  return useFloating({
    elements: {
      floating: popperElement,
      reference: referenceElement,
    },
    placement: 'right',
    strategy: 'fixed',
    middleware: [
      offset(({ rects }) => {
        // When in "infinity" mode, the menu should be centered above the "reference" element
        if (isInfinityMode) {
          return {
            mainAxis: -0.5 * (rects.floating.width + rects.reference.width),
          };
        }

        // By default, the menu should be placed to the right of the "reference" element, slightly overlapping it
        return {
          mainAxis: -8,
        };
      }),
      shift({ padding: 8 }),
    ],
    whileElementsMounted: autoUpdate,
  });
};
